var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 29,
    viewBox: "0 0 42 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3126 1.48744L41.3125 13.4874C42.2125 14.2874 42.2125 15.6874 41.3125 16.4874L29.3126 28.4874C28.0126 29.6374 26.0126 28.6874 26.0126 26.9874V19.9874C26.0126 19.4374 25.5626 18.9874 25.0126 18.9874H2.01256C0.912564 18.9874 0.0125629 18.0874 0.0125629 16.9874V12.9874C0.0125629 11.8874 0.912564 10.9874 2.01256 10.9874H25.0126C25.5626 10.9874 26.0126 10.5374 26.0126 9.98744V2.98744C26.0126 1.28744 28.0126 0.337443 29.3126 1.48744Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.fdb5d79f17c67c219f4f72803386d912.svg";
export { ForwardRef as ReactComponent };